<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 12.4913C5 12.2757 5.07964 12.0601 5.23946 11.8956L9.025 7.99996L5.23946 4.10428C4.92036 3.77529 4.92036 3.24194 5.23946 2.91295C5.5591 2.58452 6.0773 2.58452 6.39694 2.91295L10.7607 7.40429C11.0798 7.73329 11.0798 8.26663 10.7607 8.59562L6.39694 13.087C6.0773 13.4154 5.5591 13.4154 5.23946 13.087C5.07964 12.9225 5 12.7069 5 12.4913Z"
      fill=""
    />
  </svg>
</template>
